webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Hello__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Hello__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Hello___default.a
  }]
}));

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(10)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(19),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reset_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(3);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_reset_css___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },

  methods: {
    scrollAnchor: function scrollAnchor(anchor) {
      var speed = 400;
      var position = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(anchor).offset().top;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body, html').animate({ scrollTop: position }, speed, 'swing');
      return false;
    }
  }
});

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mauloa-logo-white.7903409.svg";

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mauloa-logo.be4f864.svg";

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(9)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(18),
  /* scopeId */
  "data-v-151ad233",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('nav', {
    staticClass: "navigation"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(16)
    },
    on: {
      "click": function($event) {
        _vm.scrollAnchor('html')
      }
    }
  }), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.scrollAnchor('.news')
      }
    }
  }, [_vm._v("News")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.scrollAnchor('.about')
      }
    }
  }, [_vm._v("About")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.scrollAnchor('.lesson')
      }
    }
  }, [_vm._v("Lesson")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.scrollAnchor('.class')
      }
    }
  }, [_vm._v("Class")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.scrollAnchor('.timetable')
      }
    }
  }, [_vm._v("Time")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.scrollAnchor('.staff')
      }
    }
  }, [_vm._v("Staff")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.scrollAnchor('.contact')
      }
    }
  }, [_vm._v("Contact")])])])]), _vm._v(" "), _c('section', {
    staticClass: "main"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(15)
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "comment"
  }, [_vm._v("無料体験OK!!　*事前予約をお願いします")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("仙台駅東口から徒歩7分"), _c('br'), _vm._v("初心者からインストラクターを目指す方まで"), _c('br'), _vm._v("本格的なフラを習えます")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "comment"
  }, [_vm._v("2019年3月末日迄ご入会の方に入会金25％OFF＆"), _c('br'), _vm._v("マウロアオリジナルTシャツプレゼント!!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "news"
  }, [_c('div', {
    staticClass: "content-center"
  }, [_c('h1', [_vm._v("News")]), _vm._v(" "), _c('section', [_c('h2', [_vm._v("2019.9.7(土)")]), _vm._v(" "), _c('p', [_vm._v("8th 伊達なHula Festa 福祉プラザ2Fふれあいホールにて開催決定")])]), _vm._v(" "), _c('section', [_c('h2', [_vm._v("2018.7.8(日)")]), _vm._v(" "), _c('p', [_vm._v("7th 伊達なHula Festa"), _c('br'), _vm._v("福祉プラザ アウアナ、カヒコ、タヒチアンに加えて"), _c('br'), _vm._v("\n        今年も県外よりカネダンサーを招待"), _c('br'), _vm._v("フラショップも出店します")])]), _vm._v(" "), _c('section', [_c('h2', [_vm._v("2017.11.3(金) 祝日")]), _vm._v(" "), _c('p', [_vm._v("青葉区民まつり"), _c('br'), _vm._v(" HulaとUkulele&Hulaの両方での参加です")])]), _vm._v(" "), _c('section', [_c('h2', [_vm._v("2017.8.18(土)")]), _vm._v(" "), _c('p', [_vm._v("E BeanS杜のテラスにてライブ "), _c('br'), _vm._v("18:30～ 19:30～の2回ステージ")])]), _vm._v(" "), _c('section', [_c('h2', [_vm._v("2017.8.6(日)")]), _vm._v(" "), _c('p', [_vm._v("イロハ横丁七夕イベント"), _c('br'), _vm._v("今年で3回目の参加になります"), _c('br'), _vm._v("・13:00～ Hula"), _c('br'), _vm._v("・15:30～ Ukulele&Hula")])]), _vm._v(" "), _c('section', [_c('h2', [_vm._v("2017.7.1(土)")]), _vm._v(" "), _c('p', [_vm._v("6th伊達なHula Festa 福祉プラザにて開催"), _c('br'), _vm._v(" カヒコ、ケイキさんに加えて、"), _c('br'), _vm._v("今回は県外よりカネダンサーを招待")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "about"
  }, [_c('h1', [_vm._v("About")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "accent"
  }, [_vm._v("「マウロア」")]), _vm._v("とは、ハワイ語で、「永遠」という意味です。"), _c('br'), _vm._v(" 生徒さんは、オハナ(家族)としてレッスンを共に励み、人と人の繋がりも大切にしています。 ")]), _vm._v(" "), _c('ul', {
    staticClass: "bold"
  }, [_c('li', [_vm._v("＊ レッスンでは基礎を大切にして、美しく踊ることを一番の目標にしています。")]), _vm._v(" "), _c('li', [_vm._v("＊ "), _c('span', {
    staticClass: "accent"
  }, [_vm._v("マウロア レッスンの特徴")]), _vm._v(" やわらかに踊る"), _c('br'), _vm._v("アウアナだけでなく、各フラの楽器(ウリウリ、イプ、プイリ)を使って楽しく踊ります。")]), _vm._v(" "), _c('li', [_vm._v("＊ 古典フラのカヒコもご指導しています")]), _vm._v(" "), _c('li', [_vm._v("＊ ウクレレとフラソングも楽しくレッスンをしています。 ")])]), _vm._v(" "), _c('p', [_vm._v("以上のようにマウロアでは様々な種類のレッスンを受けることが出来ますので\n    更にフラを身近に感じることができます。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "lesson"
  }, [_c('div', {
    staticClass: "content-center"
  }, [_c('h1', [_vm._v("Lesson")]), _vm._v(" "), _c('ul', {
    staticClass: "bold"
  }, [_c('li', [_vm._v("＊カヒコ(古典フラ)")]), _vm._v(" "), _c('li', [_vm._v("＊アウアナ(現代フラ)")]), _vm._v(" "), _c('li', [_vm._v("＊各楽器(イプ、ウリウリ、プイリ 他)")]), _vm._v(" "), _c('li', [_vm._v("＊ウクレレ＆フラソング ")]), _vm._v(" "), _c('li', [_vm._v("＊パーティ・イベントでの生演奏")]), _vm._v(" "), _c('li', [_vm._v("＊出張レッスン")]), _vm._v(" "), _c('li', [_vm._v("＊ワークショップ(ご相談ください) 慰問活動(ボランティア)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "class"
  }, [_c('div', {
    staticClass: "content-center"
  }, [_c('h1', [_vm._v("Class")]), _vm._v(" "), _c('section', {
    staticClass: "class-addmission"
  }, [_c('h2', [_vm._v("入会金")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('td', [_vm._v("フラ"), _c('br'), _vm._v("(マウロアオリジナルTシャツ、ＣＤ、ファイル付)")]), _c('td', [_vm._v("13,000円")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ウクレレ")]), _c('td', [_vm._v("3,000円")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("カヒコ"), _c('br'), _vm._v("(マウロアオリジナルTシャツ、ＣＤ、ファイル付)")]), _c('td', [_vm._v("8,000円"), _c('br')])])])]), _vm._v(" "), _c('section', {
    staticClass: "class-addmission"
  }, [_c('h2', [_vm._v("レッスン料金"), _c('span', [_vm._v("（レッスンは基本的に月4回となります）")])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('td', [_vm._v("初級クラス(80分)")]), _c('td', [_vm._v("7,300円")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("中級クラス(80分)")]), _c('td', [_vm._v("8,800円")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("インストラクタークラス")]), _c('td', [_vm._v("15,000円")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ガールズクラス"), _c('br'), _vm._v("(高校生まで:80分)")]), _c('td', [_vm._v("5,800円")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("カネクラス(80分)")]), _c('td', [_vm._v("8,500円")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ケイキクラス"), _c('br'), _vm._v("(小学生)")]), _c('td', [_vm._v("5,800円")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ママ＆ケイキクラス"), _c('br'), _vm._v("(幼児)(80分)")]), _c('td', [_vm._v("6,800円")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("マダムのゆったりフラ"), _c('br'), _vm._v("(月に2回70分)")]), _c('td', [_vm._v("4,000円")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("カヒコクラス"), _c('br'), _vm._v("(月2回:60分)")]), _c('td', [_vm._v("5,000円")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("個人レッスン"), _c('br'), _vm._v("(1レッスン:80分)")]), _c('td', [_vm._v("6,000円")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ウクレレ＆フラソング 初級"), _c('br'), _vm._v("(月2回:60分)")]), _c('td', [_vm._v("3,000円")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ウクレレ＆フラソング 初級"), _c('br'), _vm._v("(月4回:60分)")]), _c('td', [_vm._v("5,500円")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ウクレレ＆フラソング 中級"), _c('br'), _vm._v("(月2回:60分)")]), _c('td', [_vm._v("4,000円")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ウクレレ＆フラソング 中級"), _c('br'), _vm._v("(月4回:60分)")]), _c('td', [_vm._v("7,500円")])])])]), _vm._v(" "), _c('p', {
    staticClass: "class-annotation"
  }, [_vm._v("※全てのレッスンは曜日･時間について相談に応じることが可能です")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "timetable"
  }, [_c('div', {
    staticClass: "content-center"
  }, [_c('h1', [_vm._v("Time Table")]), _vm._v(" "), _c('section', [_c('h2', [_vm._v("火曜日")]), _vm._v(" "), _c('p', [_vm._v("15:30～16:50(80分) 初級・中級"), _c('br'), _vm._v("18:00～19:20(80分) 初級・中級")])]), _vm._v(" "), _c('section', [_c('h2', [_vm._v("金曜日"), _c('span', [_vm._v("(基本は第1・第3の月2回 ※相談可)")])]), _vm._v(" "), _c('p', [_vm._v("18:30～19:30(60分) 中級"), _c('br'), _vm._v("19:30～20:30(60分) カヒコ")])]), _vm._v(" "), _c('section', [_c('h2', [_vm._v("土曜日")]), _vm._v(" "), _c('p', [_vm._v("\n        9:50～11:10(80分) 初級・ケイキ"), _c('br'), _vm._v("\n        15:00～16:00(60分) ウクレレ"), _c('br'), _c('br'), _vm._v("\n        ＜カヒコのある日＞"), _c('br'), _vm._v("\n        16:00〜17:00(60分) カヒコ 月2回"), _c('br'), _vm._v("\n        17:00〜18:20(80分) 中級〜(初級)"), _c('br'), _c('br'), _vm._v("\n        ＜カヒコのない日＞"), _c('br'), _vm._v("\n        16:00〜17:20(80分) 中級〜(初級)"), _c('br'), _vm._v("\n        17:30〜18:50(80分) インストラクター(月2回)\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "staff"
  }, [_c('div', {
    staticClass: "content-center"
  }, [_c('h1', [_vm._v("Staff")]), _vm._v(" "), _c('section', [_c('h2', [_vm._v("主宰")]), _vm._v(" "), _c('p', [_vm._v("安達 幸子 (Eneo Anela Sachiko)")])]), _vm._v(" "), _c('section', [_c('h2', [_vm._v("インストラクター")]), _vm._v(" "), _c('p', [_vm._v("安逹 沙綾 (Hibiscus Ho'okomo koko Saaya)"), _c('br'), _vm._v("高橋 ルミ（Anapa Hoku-ke'a Lumi）")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "contact"
  }, [_c('div', {
    staticClass: "content-center"
  }, [_c('h1', [_vm._v("Contact")]), _vm._v(" "), _c('section', [_c('h2', [_vm._v("フラスタジオ・マウロア")]), _vm._v(" "), _c('p', [_vm._v("〒983-0852"), _c('br'), _vm._v(" 宮城県仙台市宮城野区榴岡3-2-5"), _c('br'), _vm._v("仙台銀行2F Lスタジオ内"), _c('br'), _c('br'), _vm._v("TEL.090-2884-4791(10:00～20:00 安達)")]), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3132.841549315829!2d140.88435355985425!3d38.259980800503484!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5f8a281f23ea1863%3A0x69497a2ba9daa468!2z5LuZ5Y-w6YqA6KGM5a6u5Z-O6YeO5pSv5bqX!5e0!3m2!1sja!2sjp!4v1506902968392",
      "width": "100%",
      "height": "300",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('p', [_vm._v("©2010-2017 Hula Studio Mauloa.")])])
}]}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ })
],[6]);


// WEBPACK FOOTER //
// static/js/app.a09964f22e7859140c07.js